import { render, staticRenderFns } from "./select-gun.vue?vue&type=template&id=87c8c388"
import script from "./select-gun.vue?vue&type=script&lang=ts"
export * from "./select-gun.vue?vue&type=script&lang=ts"
import style0 from "./select-gun.vue?vue&type=style&index=0&id=87c8c388&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports